module.exports = __webpack_public_path__ + "img/NINEMOBILE.1a7d1678.svg";